<template>
  <div class="password-validator mt-2">
    <small class="text-muted">
      La contraseña debe contener:
    </small>
    <ul class="list-unstyled mt-1" style="font-size: 0.75rem;">
      <li class="d-flex align-items-center">
        <i :class="requirements.length ? 'ni ni-check-bold text-success' : 'ni ni-fat-remove text-danger'" class="me-1"></i>
        Al menos 8 caracteres
      </li>
      <li class="d-flex align-items-center">
        <i :class="requirements.uppercase ? 'ni ni-check-bold text-success' : 'ni ni-fat-remove text-danger'" class="me-1"></i>
        Una letra mayúscula
      </li>
      <li class="d-flex align-items-center">
        <i :class="requirements.lowercase ? 'ni ni-check-bold text-success' : 'ni ni-fat-remove text-danger'" class="me-1"></i>
        Una letra minúscula
      </li>
      <li class="d-flex align-items-center">
        <i :class="requirements.number ? 'ni ni-check-bold text-success' : 'ni ni-fat-remove text-danger'" class="me-1"></i>
        Un número
      </li>
      <li class="d-flex align-items-center">
        <i :class="requirements.symbol ? 'ni ni-check-bold text-success' : 'ni ni-fat-remove text-danger'" class="me-1"></i>
        Un símbolo (!@#$%^&*_...)
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  password: {
    type: String,
    default: '',
    required: true
  }
});

const requirements = computed(() => ({
  length: props.password.length >= 8,
  uppercase: /[A-Z]/.test(props.password),
  lowercase: /[a-z]/.test(props.password),
  number: /[0-9]/.test(props.password),
  symbol: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(props.password)
}));

// Exponer una función para validar externamente
const isValid = computed(() => {
  return Object.values(requirements.value).every(req => req);
});

// Función para obtener mensaje de error específico
const getValidationMessage = () => {
  if (!requirements.value.length) {
    return 'La contraseña debe tener al menos 8 caracteres';
  }
  if (!requirements.value.uppercase) {
    return 'La contraseña debe contener al menos una letra mayúscula';
  }
  if (!requirements.value.lowercase) {
    return 'La contraseña debe contener al menos una letra minúscula';
  }
  if (!requirements.value.number) {
    return 'La contraseña debe contener al menos un número';
  }
  if (!requirements.value.symbol) {
    return 'La contraseña debe contener al menos un símbolo o carácter especial';
  }
  return null;
};

defineExpose({
  isValid,
  getValidationMessage,
  requirements
});
</script>

<style scoped>
.list-unstyled {
  list-style: none;
  padding-left: 0;
}

.list-unstyled li {
  padding: 0.25rem 0;
}

.password-validator {
  transition: all 0.3s ease;
}
</style>